import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft, faCameraRetro, faImages, faCalendarAlt, faGlobe
} from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";

const API_URL = process.env.REACT_APP_API_URL;

export default function AutorDetalhe() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { get } = useFetch();

    const [state, setState] = useState({ autor: null, obras: [], loading: true });

    useEffect(() => {
        window.scrollTo(0, 0);
        async function carregar() {
            try {
                let response = await get(`/acervo/autores/${id}`);
                if (response.ok && response.result.data) {
                    setState({ autor: response.result.data.autor, obras: response.result.data.obras ?? [], loading: false });
                } else {
                    setState({ autor: null, obras: [], loading: false });
                }
            } catch (error) {
                console.error("Erro no carregar():", error);
                setState({ autor: null, obras: [], loading: false });
            }
        }
        carregar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (state.loading) {
        return <Container className="py-5" style={{marginTop: '100px'}}><div className="text-center"><div className="spinner-border text-teal"></div></div></Container>;
    }

    if (!state.autor) return <Container className="py-5" style={{marginTop: '100px'}}><h3>Autor não encontrado</h3></Container>;

    const autor = state.autor;

    const formatarData = (data) => {
        if (!data) return "---";
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
    };

    return (
        <div className="detail-page-wrapper pb-5">
            <Container>
                <div className="mb-4">
                    <button onClick={() => navigate(-1)} className="btn-back-modern">
                        <FontAwesomeIcon icon={faChevronLeft} className="me-2" />
                        Voltar
                    </button>
                </div>

                <div className="section-title-modern mb-5">
                    <div className="title-accent"></div>
                    <h2 className="title-text">{autor.nome}</h2>
                </div>

                <Row className="g-4">
                    <Col lg={4}>
                        <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4">
                            <div className="bg-teal p-4 text-white text-center">
                                <FontAwesomeIcon icon={faCameraRetro} size="3x" className="mb-3 opacity-50" />
                                <h5 className="mb-0">Informações do Autor</h5>
                            </div>
                            <Card.Body className="p-4">
                                <div className="info-item mb-4">
                                    <small className="text-muted d-block fw-bold small text-uppercase">
                                        <FontAwesomeIcon icon={faGlobe} className="me-1" /> Nacionalidade
                                    </small>
                                    <span className="fw-bold text-dark">{autor.nacionalidade || "Não informada"}</span>
                                </div>

                                <div className="info-item mb-4">
                                    <small className="text-muted d-block fw-bold small text-uppercase">
                                        <FontAwesomeIcon icon={faCalendarAlt} className="me-1" /> Nascimento
                                    </small>
                                    <span className="fw-bold text-dark">{formatarData(autor.data_nascimento)}</span>
                                </div>

                                <div className="info-item">
                                    <small className="text-muted d-block fw-bold small text-uppercase">
                                        <FontAwesomeIcon icon={faCalendarAlt} className="me-1" /> Falecimento
                                    </small>
                                    <span className="fw-bold text-dark">{formatarData(autor.data_falecimento)}</span>
                                </div>
                            </Card.Body>
                        </Card>

                        <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-4">
                            <h6 className="fw-bold text-teal mb-2">
                                <FontAwesomeIcon icon={faImages} className="me-2" />
                                Acervo do Museu
                            </h6>
                            <p className="small text-muted mb-0">
                                Total de <strong>{state.obras.length} obras</strong> atribuídas a este autor.
                            </p>
                        </div>
                    </Col>

                    <Col lg={8}>
                        <div className="related-works-section">
                            <div className="d-flex align-items-center mb-4">
                                <h4 className="text-dark fw-bold mb-0">Obras deste Autor</h4>
                                <div className="ms-3 flex-grow-1 border-bottom"></div>
                            </div>

                            <Row className="g-4">
                                {state.obras.map(obra => (
                                    <Col md={6} key={obra.id_fotografia}>
                                        <Link to={`/acervo/iconografia/${obra.id_fotografia}`} className="text-decoration-none">
                                            <Card className="photo-result-card border-0 shadow-sm h-100">
                                                <div className="photo-container">
                                                    <Badge className="tombo-badge">{obra.numero_tombo}</Badge>
                                                    <img src={`${API_URL}/acervo/fotografias/${obra.id_fotografia}/imagem`} alt={obra.titulo_atribuido} onError={(e) => { e.target.style.display = 'none'; }} />
                                                </div>
                                                <Card.Body className="p-3">
                                                    <h6 className="photo-title-main mb-1 text-truncate">{obra.titulo_atribuido}</h6>
                                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                                        <small className="text-muted">{obra.ano_producao ?? "-"}</small>
                                                        <span className="small text-teal fw-bold">Ver detalhes →</span>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                ))}
                            </Row>

                            {state.obras.length === 0 && (
                                <div className="text-center py-5 bg-white rounded-4 shadow-sm">
                                    <p className="text-muted">Nenhuma outra obra deste autor encontrada no momento.</p>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
